import {Card, Box, Typography, Link} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {CTAProps} from '../type';
import {ChevronRight} from '@jobseeker/lotus/icons';
import {getReplacedString} from '@jobseeker/lotus/utils';

export default ({children, cardSxProps = {}, ...props}: CTAProps) => {
  return (
    <Card
      sx={{
        borderRadius: 4,
        position: 'relative',
        ...cardSxProps,
      }}
    >
      {props.cardInfo?.map((info, index) => {
        const showDivider = props?.cardInfo?.length
          ? index < props?.cardInfo?.length - 1
          : false;

        const title =
          typeof info.title === 'string'
            ? getReplacedString(
                info?.title || '',
                props?.valueToReplace || '',
                props?.dynamicValue || ''
              )
            : info.title;

        return (
          <>
            <Box
              key={`lotus-CTA-v6-${index}`}
              data-testid={`lotus-cta-v6-${(typeof info.title === 'string'
                ? info?.title
                : ''
              )
                ?.toLowerCase()
                ?.replace(/ /g, '-')}`}
              px={2}
              py={1.5}
              sx={{
                wordBreak: 'break-word',
                borderBottom: showDivider
                  ? '1px solid rgba(126, 126, 126, 0.2)'
                  : '',
              }}
            >
              {title && (
                <Typography
                  fontSize={12}
                  fontWeight="500"
                  sx={{wordWrap: 'break-word'}}
                  color="text.secondary"
                >
                  {title}
                </Typography>
              )}
              {info?.subTitle && (
                <Typography fontSize={12} mt={0.5} fontWeight="400">
                  {info.subTitle}
                </Typography>
              )}
              {info.actionLabel && (
                <Link
                  href={info.actionUrl}
                  target="_self"
                  sx={{
                    textDecoration: 'none',
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    mt: 0.25,
                  }}
                >
                  <Typography fontSize={12} color="primary" fontWeight="medium">
                    {info.actionLabel}
                  </Typography>
                  <Box component={'span'} sx={{mx: 0.25}}>
                    <Image
                      src={ChevronRight}
                      alt={'Arrow'}
                      width={10}
                      height={10}
                      objectFit="cover"
                    />
                  </Box>
                </Link>
              )}
            </Box>
          </>
        );
      })}
    </Card>
  );
};
